export default "__VITE_ASSET__B0BRLY3g__"